// import React, { useState } from 'react';
// import { 
//   Box, 
//   Typography, 
//   TextField, 
//   Button, 
//   Dialog, 
//   DialogTitle, 
//   DialogContent, 
//   DialogActions,
//   CircularProgress,
//   Snackbar,
//   Alert,
//   IconButton,
//   useMediaQuery,
//   useTheme,
//   Paper,
//   Divider
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import SendIcon from '@mui/icons-material/Send';
// import HomeIcon from '@mui/icons-material/Home';
// import MessageIcon from '@mui/icons-material/Message';
// import axios from 'axios';

// const CreateInquiry = ({ open, onClose, propertyId, buyerId, propertyTitle }) => {
//   const [inquiryText, setInquiryText] = useState('I am interested in this property. Can I schedule a visit?');
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: '',
//     severity: 'success'
//   });
  
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   const handleSubmit = async () => {
//     if (!inquiryText.trim()) {
//       setSnackbar({
//         open: true,
//         message: 'Please enter an inquiry message',
//         severity: 'error'
//       });
//       return;
//     }

//     setLoading(true);
//     try {
//       const response = await axios.post(
//         'https://propertydealstalk.com/api/messaging/createInquiry',
//         {
//           buyer_id: buyerId,
//           property_id: propertyId,
//           inquiry_text: inquiryText
//         }
//       );

//       if (response.data.statusCode === 200) {
//         setSnackbar({
//           open: true,
//           message: 'Inquiry sent successfully!',
//           severity: 'success'
//         });
//         setInquiryText('I am interested in this property. Can I schedule a visit?');
//         onClose();
//       } else {
//         throw new Error(response.data.message || 'Failed to send inquiry');
//       }
//     } catch (error) {
//       console.error('Error sending inquiry:', error);
//       setSnackbar({
//         open: true,
//         message: error.message || 'Failed to send inquiry. Please try again.',
//         severity: 'error'
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   return (
//     <>
//       <Dialog 
//         open={open} 
//         onClose={onClose}
//         fullWidth
//         maxWidth="sm"
//         fullScreen={isMobile}
//         PaperProps={{
//           sx: {
//             borderRadius: isMobile ? 0 : '12px',
//             width: '100%',
//             maxHeight: '90vh',
//             fontFamily: 'Outfit, sans-serif'
//           }
//         }}
//       >
//         <DialogTitle sx={{ 
//           display: 'flex', 
//           justifyContent: 'space-between', 
//           alignItems: 'center',
//           borderBottom: '1px solid #eee',
//           pb: 2,
//           background: '#f8faff',
//           fontFamily: 'Outfit, sans-serif'
//         }}>
//           <Typography 
//             variant="h6" 
//             component="div" 
//             sx={{ 
//               fontWeight: 600, 
//               color: '#2563EB',
//               fontFamily: 'Outfit, sans-serif',
//               display: 'flex',
//               alignItems: 'center',
//               gap: 1
//             }}
//           >
//             <MessageIcon fontSize="small" /> Contact Property Owner
//           </Typography>
//           <IconButton onClick={onClose} size="small">
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent sx={{ pt: 3, pb: 3, fontFamily: 'Outfit, sans-serif' }}>
//           <Paper elevation={0} sx={{ 
//             p: 2, 
//             mb: 3, 
//             background: '#f8faff', 
//             border: '1px solid #e6effd',
//             borderRadius: '10px'
//           }}>
//             <Typography 
//               variant="subtitle1" 
//               sx={{ 
//                 fontWeight: 600, 
//                 mb: 0.5, 
//                 color: '#2563EB',
//                 fontFamily: 'Outfit, sans-serif',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 1
//               }}
//             >
//               <HomeIcon fontSize="small" /> Property
//             </Typography>
//             <Typography 
//               variant="body1" 
//               sx={{ 
//                 fontWeight: 500,
//                 fontFamily: 'Outfit, sans-serif'
//               }}
//             >
//               {propertyTitle || 'Luxury Apartment'}
//             </Typography>
//           </Paper>

//           <Box sx={{ mb: 3 }}>
//             <Typography 
//               variant="subtitle1" 
//               sx={{ 
//                 fontWeight: 600, 
//                 mb: 1, 
//                 color: '#2563EB',
//                 fontFamily: 'Outfit, sans-serif',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 1
//               }}
//             >
//               <MessageIcon fontSize="small" /> Your Message
//             </Typography>
//             <TextField
//               fullWidth
//               multiline
//               rows={4}
//               variant="outlined"
//               value={inquiryText}
//               onChange={(e) => setInquiryText(e.target.value)}
//               placeholder="Write your inquiry here..."
//               sx={{
//                 '& .MuiOutlinedInput-root': {
//                   borderRadius: '8px',
//                   fontFamily: 'Outfit, sans-serif'
//                 },
//                 '& .MuiInputBase-input': {
//                   fontFamily: 'Outfit, sans-serif'
//                 }
//               }}
//             />
//           </Box>

//           <Divider sx={{ my: 2 }} />

//           <Typography 
//             variant="body2" 
//             sx={{ 
//               color: '#666',
//               fontFamily: 'Outfit, sans-serif',
//               fontStyle: 'italic'
//             }}
//           >
//             By sending this inquiry, you agree to our terms of service and privacy policy.
//           </Typography>
//         </DialogContent>

//         <DialogActions sx={{ 
//           p: 2, 
//           borderTop: '1px solid #eee',
//           display: 'flex',
//           justifyContent: 'space-between',
//           flexDirection: isMobile ? 'column' : 'row',
//           gap: isMobile ? 2 : 0,
//           background: '#f8faff'
//         }}>
//           <Button 
//             onClick={onClose} 
//             variant="outlined"
//             sx={{ 
//               borderRadius: '8px',
//               width: isMobile ? '100%' : 'auto',
//               fontFamily: 'Outfit, sans-serif',
//               textTransform: 'none',
//               fontWeight: 500
//             }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleSubmit}
//             variant="contained"
//             disabled={loading}
//             startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
//             sx={{ 
//               borderRadius: '8px',
//               backgroundColor: '#2563EB',
//               '&:hover': {
//                 backgroundColor: '#1E40AF',
//               },
//               width: isMobile ? '100%' : 'auto',
//               fontFamily: 'Outfit, sans-serif',
//               textTransform: 'none',
//               fontWeight: 500,
//               py: 1
//             }}
//           >
//             {loading ? 'Sending...' : 'Send Inquiry'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar 
//         open={snackbar.open} 
//         autoHideDuration={6000} 
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert 
//           onClose={handleCloseSnackbar} 
//           severity={snackbar.severity}
//           sx={{ 
//             width: '100%',
//             fontFamily: 'Outfit, sans-serif'
//           }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// export default CreateInquiry;



// src/components/property/CreateInquiry.jsx



import React, { useState, useEffect, useRef } from 'react';
import { 
  Box, 
  Typography, 
  TextField, 
  Button, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions,
  CircularProgress,
  Snackbar,
  Alert,
  IconButton,
  useMediaQuery,
  useTheme,
  Paper,
  Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import HomeIcon from '@mui/icons-material/Home';
import MessageIcon from '@mui/icons-material/Message';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import socketService from '../../../services/socketService';
import socketEvents from '../../../services/socketEvents';

const CreateInquiry = ({ open, onClose, propertyId, buyerId, propertyTitle }) => {
  const [inquiryText, setInquiryText] = useState('I am interested in this property. Can I schedule a visit?');
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();
  const socketInitializedRef = useRef(false);

  useEffect(() => {
    if (open && !socketInitializedRef.current) {
      console.log('🔌 Initializing socket for CreateInquiry...');
      
      const authToken = user?.token || localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');
      
      socketService.connect('https://propertydealstalk.com', {
        extraHeaders: authToken ? { 'Authorization': `Bearer ${authToken}` } : {}
      }).then(() => {
        console.log('📝 Registering inquiry event handlers...');
        
        const handleInquiryCreated = (data) => {
          console.log('✅ Inquiry created successfully:', data);
          setLoading(false);
          setSnackbar({
            open: true,
            message: 'Inquiry sent successfully! Redirecting to inbox...',
            severity: 'success'
          });
          setInquiryText('I am interested in this property. Can I schedule a visit?');
          
          setTimeout(() => {
            onClose();
            navigate('/profile?tab=inbox');
          }, 1500);
        };

        const handleSocketError = (error) => {
          console.error('🔥 Socket error:', error);
          setLoading(false);
          setSnackbar({
            open: true,
            message: error.message || 'Failed to send inquiry. Please try again.',
            severity: 'error'
          });
        };

        socketEvents.registerEvents({
          onInquiryCreated: handleInquiryCreated,
          onError: handleSocketError
        });
        
        socketInitializedRef.current = true;
      }).catch(error => {
        console.error('Failed to connect socket:', error);
        setSnackbar({
          open: true,
          message: 'Connection failed. Please try again.',
          severity: 'error'
        });
      });
    }
  }, [open, user, onClose, navigate]);

  const handleSubmit = async () => {
    if (!inquiryText.trim()) {
      setSnackbar({
        open: true,
        message: 'Please enter an inquiry message',
        severity: 'error'
      });
      return;
    }

    if (!buyerId) {
      setSnackbar({
        open: true,
        message: 'Please log in to send an inquiry',
        severity: 'error'
      });
      return;
    }

    if (!propertyId) {
      setSnackbar({
        open: true,
        message: 'Invalid property',
        severity: 'error'
      });
      return;
    }

    setLoading(true);

    try {
      console.log('📤 Sending inquiry...');
      console.log('Data:', {
        buyer_id: buyerId,
        property_id: propertyId,
        inquiry_text: inquiryText
      });
const isConnected = socketService.isSocketConnected();
console.log('🔍 Socket connected:', isConnected);
if (!isConnected)
   {
        console.log('⚠️ Socket not connected, waiting...');
        await socketService.connect('https://propertydealstalk.com');
      }

      console.log('✅ Socket connected, emitting create_inquiry...');
      socketEvents.createInquiry(buyerId, propertyId, inquiryText);

      setTimeout(() => {
        if (loading) {
          console.log('⏰ Timeout waiting for response, assuming success...');
          setLoading(false);
          setSnackbar({
            open: true,
            message: 'Inquiry sent! Please check your inbox.',
            severity: 'success'
          });
          setInquiryText('I am interested in this property. Can I schedule a visit?');
          
          setTimeout(() => {
            onClose();
            navigate('/profile?tab=inbox');
          }, 1500);
        }
      }, 5000);

    } catch (error) {
      console.error('❌ Error sending inquiry:', error);
      setLoading(false);
      setSnackbar({
        open: true,
        message: error.message || 'Failed to send inquiry. Please try again.',
        severity: 'error'
      });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleClose = () => {
    if (!loading) {
      setInquiryText('I am interested in this property. Can I schedule a visit?');
      socketInitializedRef.current = false;
      onClose();
    }
  };

  return (
    <>
      <Dialog 
        open={open} 
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            borderRadius: isMobile ? 0 : '12px',
            width: '100%',
            maxHeight: '90vh',
            fontFamily: 'Outfit, sans-serif'
          }
        }}
      >
        <DialogTitle sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          borderBottom: '1px solid #eee',
          pb: 2,
          background: '#f8faff',
          fontFamily: 'Outfit, sans-serif'
        }}>
          <Typography 
            variant="h6" 
            component="div" 
            sx={{ 
              fontWeight: 600, 
              color: '#2563EB',
              fontFamily: 'Outfit, sans-serif',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            <MessageIcon fontSize="small" /> Contact Property Owner
          </Typography>
                    <IconButton onClick={handleClose} size="small" disabled={loading}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ pt: 3, pb: 3, fontFamily: 'Outfit, sans-serif' }}>
          <Paper 
            elevation={0} 
            sx={{ 
              p: 2, 
              mb: 3, 
              bgcolor: '#f8faff', 
              border: '1px solid #e3f2fd',
              fontFamily: 'Outfit, sans-serif'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <HomeIcon sx={{ color: '#2563EB', fontSize: 20 }} />
              <Typography 
                variant="subtitle2" 
                sx={{ 
                  fontWeight: 600, 
                  color: '#2563EB',
                  fontFamily: 'Outfit, sans-serif'
                }}
              >
                Property Details
              </Typography>
            </Box>
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#555',
                fontFamily: 'Outfit, sans-serif',
                fontSize: 14
              }}
            >
              {propertyTitle || 'Selected Property'}
            </Typography>
            <Typography 
              variant="caption" 
              sx={{ 
                color: '#888', 
                mt: 0.5, 
                display: 'block',
                fontFamily: 'Outfit, sans-serif'
              }}
            >
              Property ID: #{propertyId}
            </Typography>
          </Paper>

          <Typography 
            variant="subtitle2" 
            sx={{ 
              mb: 1.5, 
              fontWeight: 600, 
              color: '#333',
              fontFamily: 'Outfit, sans-serif'
            }}
          >
            Your Message to Owner
          </Typography>

          <TextField
            fullWidth
            multiline
            rows={6}
            value={inquiryText}
            onChange={(e) => setInquiryText(e.target.value)}
            placeholder="Write your inquiry here..."
            disabled={loading}
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Outfit, sans-serif',
                fontSize: 14,
                '&:hover fieldset': {
                  borderColor: '#2563EB',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#2563EB',
                },
              },
              '& .MuiInputBase-input': {
                fontFamily: 'Outfit, sans-serif'
              }
            }}
          />

          <Box sx={{ 
            mt: 2, 
            p: 2, 
            bgcolor: '#fff3cd', 
            borderRadius: 1, 
            border: '1px solid #ffc107'
          }}>
            <Typography 
              variant="caption" 
              sx={{ 
                color: '#856404',
                fontFamily: 'Outfit, sans-serif',
                fontSize: 13
              }}
            >
              💡 <strong>Tip:</strong> Be specific about your requirements and preferred visit times to get a faster response.
            </Typography>
          </Box>
        </DialogContent>

        <Divider />

        <DialogActions sx={{ 
          p: 2.5, 
          gap: 1.5, 
          background: '#f8faff',
          fontFamily: 'Outfit, sans-serif'
        }}>
          <Button 
            onClick={handleClose} 
            disabled={loading}
            variant="outlined"
            sx={{ 
              borderColor: '#ddd',
              color: '#666',
              textTransform: 'none',
              fontFamily: 'Outfit, sans-serif',
              fontWeight: 500,
              '&:hover': {
                borderColor: '#bbb',
                bgcolor: '#f5f5f5'
              }
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleSubmit} 
            disabled={loading || !inquiryText.trim()}
            variant="contained"
            startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <SendIcon />}
            sx={{ 
              bgcolor: '#2563EB',
              textTransform: 'none',
              fontFamily: 'Outfit, sans-serif',
              fontWeight: 500,
              minWidth: 140,
              '&:hover': {
                bgcolor: '#1e40af'
              },
              '&:disabled': {
                bgcolor: '#ccc'
              }
            }}
          >
            {loading ? 'Sending...' : 'Send Inquiry'}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity} 
          sx={{ 
            width: '100%',
            fontFamily: 'Outfit, sans-serif'
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CreateInquiry;

